// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2019":"d6209356c5b5d1c3","2740":"ce0eda8025a8ae22","2957":"bf41eff47a7692cc"}[chunkId] + ".css";
};